// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__A-DGs","active":"style_active__7zCqD"};